import { Component } from 'react';

class RoomCardTooltip extends Component {
  render() {
    const { game_info } = this.props;

    let gameImage = null;
    if (game_info && game_info !== -1) {
      const gameImagePath = new URL(`../../../static/assets/game_icons/${game_info.image_path}`, import.meta.url).href;
      gameImage = <img alt="actual_game_image" className="multiplayer_game_image" src={gameImagePath}></img>;
    }

    return <div className="room_card_tooltip tw-px-16">{gameImage}</div>;
  }
}

export default RoomCardTooltip;
